import type { ChangeEvent, FunctionComponent } from 'react';
import React from 'react';

import Form from 'src/components/ui/Form';

import type { UpdateFieldType } from '../contactForm/ContactForm';
import style from '../contactForm/ContactForm.module.scss';

import type { ContactFormData } from 'src/models/contact';

import { mergeClassNames } from 'src/utils/ReactUtils';

type TermsAndConditionsType = {
  updateField: UpdateFieldType;
  formValue: ContactFormData;
  formValidation: boolean;
};

const TermsAndConditions: FunctionComponent<TermsAndConditionsType> = ({
  updateField,
  children,
  formValue,
  formValidation,
}) => {
  return (
    <section className={style.contactForm}>
      <div
        className={mergeClassNames([
          style.contactFormContent,
          formValidation && !formValue.accept
            ? style.contactContentFullBorder
            : '',
        ])}
      >
        <Form.Group>
          <Form.Check type="checkbox" id="accept">
            <Form.Check.Input
              isValid
              name="accept"
              type="checkbox"
              required
              className={'form-check-input'}
              onChange={(e: ChangeEvent<HTMLInputElement>) =>
                updateField(e, e.target.value === 'on')
              }
            />
            <Form.Check.Label
              className={mergeClassNames([
                style.checkLabel,
                style.contactFormLabelRequired,
              ])}
            >
              {children}
            </Form.Check.Label>
            <Form.Control.Feedback type="invalid">
              Ce champ est obligatoire.
            </Form.Control.Feedback>
          </Form.Check>
        </Form.Group>
      </div>
      <div className={style.contactFormIndicator}>
        * Ces champs sont obligatoires pour valider votre prise de contact
      </div>
    </section>
  );
};

export default TermsAndConditions;
